import { createReactComponent } from '@tabler/icons-react';

export const IconCustomBorderCornersRestore = createReactComponent(
  'outline',
  'customBorderCornersRestore',
  'CustomBorderCornersRestore',
  [
    [
      'path',
      {
        key: 'iconCustomBorderCornersRestore-path',
        d: 'M13.3333 3.33325H15C15.442 3.33325 15.8659 3.50885 16.1785 3.82141C16.4911 4.13397 16.6666 4.55789 16.6666 4.99992V6.66659M16.6666 13.3333V14.9999C16.6666 15.4419 16.4911 15.8659 16.1785 16.1784C15.8659 16.491 15.442 16.6666 15 16.6666H13.3333M6.66665 16.6666H4.99998C4.55795 16.6666 4.13403 16.491 3.82147 16.1784C3.50891 15.8659 3.33331 15.4419 3.33331 14.9999V13.3333M3.33331 6.66659V4.99992C3.33331 4.55789 3.50891 4.13397 3.82147 3.82141C4.13403 3.50885 4.55795 3.33325 4.99998 3.33325H6.66665M7.1875 8.86931C7.44372 8.25429 7.89504 7.74057 8.47195 7.40728C9.04886 7.074 9.71934 6.93963 10.3801 7.0249C11.0409 7.11016 11.6553 7.41031 12.1287 7.87913C12.3465 8.0948 12.5289 8.34066 12.6713 8.60754M7 7.36931V8.86931H8.5M12.8125 11.1193C12.5563 11.7344 12.105 12.2481 11.5281 12.5814C10.9511 12.9147 10.2807 13.049 9.61987 12.9638C8.95909 12.8785 8.34467 12.5783 7.87126 12.1095C7.6862 11.9263 7.5267 11.7212 7.39557 11.5M13 12.6193V11.1193H11.5',
      },
    ],
  ]
);
